import React from "react";
import LeftPanel from "@components/common/layout/LeftPanel";
import RightPanel from "@components/common/layout/RightPanel";

export default function Layout() {
  return (
    <div className="font-inter min-h-screen sm:min-h-0 sm:h-custom-screen w-screen flex flex-col justify-center md:flex-row">
      <LeftPanel />
      <RightPanel />
    </div>
  );
}
